<template>
  <v-container
    fluid
  >
    <base-material-card
      inline
      icon="mdi-account-circle"
      title="Users"
    >
      <data-table
        ref="table"
        :fetch-from="fetchForm"
        :fields="fields"
      >
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            @click="editUser(slotData.rowData)"
            x-small
            color="primary"
          >Edit</v-btn>
        </template>
      </data-table>

    </base-material-card>
    <modal-form
      v-if="selectedUser"
      title="User"
      :show="dialog"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <v-row>
          <v-col cols="4">
            <display-field label="User">{{ selectedUser.email }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <user-group
              label="Group"
              :value="getValue(selectedUser, 'group_id')"
              @input="setValue(selectedUser, 'group_id', $event)"
            ></user-group>
          </v-col>
        </v-row>
      </v-form>
    </modal-form>
  </v-container>
</template>

<script>
  import UserService from '@/services/user'
  import DataTable from '@/components/DataTable'
  import ModalForm from '@/components/ModalForm'
  import DisplayField from '@/components/DisplayField'
  import UserGroup from '@/components/UserGroup'
  import ReactivitMixin from '@/mixins/Reactivity'

  export default {
    name: 'User',
    components: { UserGroup, DisplayField, ModalForm, DataTable },
    mixins: [
      ReactivitMixin,
    ],
    data: () => ({
      dialog: false,
      valid: true,
      fields: [
        {
          name: 'name',
          title: 'Name',
        },
        {
          name: 'email',
          title: 'Email',
        },
        {
          name: 'group.name',
          title: 'Group',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
      selectedUser: undefined,
    }),
    methods: {
      fetchForm (urls, options) {
        const us = new UserService()
        return us.list(options.params)
      },
      editUser (user) {
        this.selectedUser = user
        this.dialog = true
      },
      doSave () {
        const us = new UserService()
        us.update(this.selectedUser.id, this.selectedUser.group_id).then(() => {
          this.dialog = false
          this.$refs.table.refresh()
        })
      },
    },
  }
</script>

<style scoped>

</style>
